import { FormProvider, useForm } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { DevTool } from "@hookform/devtools"
import schema from "./Validation"
import { Grid } from "@mui/material"
import { AcademicLevel, ConsentementMultiple, MentionsLegales, RequiredFields, Submit } from "components"
import { Email, InputText, PhoneNumber, RadioButton } from "components/fields"
import { consent, defaultValues, salutations } from "services"
import useLandingPage from "../services/useLandingPage"
import { academicLevelsAdmissionParallele, LAST_FORMS } from "../services/landingPages"

// LP Admission parallèle : demande de documentation du PGE, campus de Paris uniquement
const Form = () => {
  const methods = useForm({
    defaultValues: {
      ...consent,
      lead: {
        ...defaultValues,
        Campus__c: 'Paris',
        PDFdownloaded__c: true,
        PGE__c: true,
        Salutation: ''
      }
    },
    resolver: yupResolver(schema)
  })
  const { control } = methods
  const { submit } = useLandingPage({
    campaignStatus: 'Requested',
    formId: 'DOC',
    lastForm: LAST_FORMS.admissionParallele,
    leadSource: 'LP : Demande de Doc',
    urlKey: 'ISG-LP-ADMISSION-PARALLELE'
  })

  return (
    <FormProvider {...methods}>
      <DevTool control={control} />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <RadioButton control={control} label="Civilité" name="lead.Salutation" options={salutations} required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Prénom" name="lead.FirstName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <InputText control={control} label="Nom" name="lead.LastName" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <Email control={control} label="Adresse e-mail" name="lead.Email" required />
        </Grid>
        <Grid item sm={6} xs={12}>
          <PhoneNumber control={control} name="lead.MobilePhone" label="Téléphone" required />
        </Grid>
        <AcademicLevel options={academicLevelsAdmissionParallele} section={false} specialites={false} />
        <ConsentementMultiple />
        <RequiredFields />
        <Submit label="Je valide" onSubmit={submit} />
        <MentionsLegales form="Documentation" school="ISG France" />
      </Grid>
    </FormProvider>
  )
}

export default Form
